import * as React from 'react';
import CircularButtonContainer from './CircularButtonContainer';

interface props {
  onClick: Function;
  style?: React.CSSProperties;
}

const PlusButton = (props: props) => {
  return (
    <CircularButtonContainer onClick={() => props.onClick()} style={props.style}>
      +
    </CircularButtonContainer>
  );
};

export default PlusButton;



// WEBPACK FOOTER //
// ./src/components/Buttons/PlusButton.tsx